import { AxiosResponse } from "axios";
import { axiosInstance } from "../../AxiosInterceptor";
import { getRegistrationMetaViewModel, createGroupModuleExternalRedirect} from "./ApiUrl.CreateScorecard";

export const createScorecardService = {
    CreateScorecard:(scorecardId : string, navigate: (path: string) => void): Promise<AxiosResponse<string[]>> => {
        return axiosInstance.get(`${getRegistrationMetaViewModel}?id=${scorecardId}`)
            .then((response) => {
                navigate(`/bee/scorecard/${scorecardId}/createscorecard`);
                return response;
            })
            .catch((error) => {
                console.error(error);
                throw error;
            });
    },

    CreateGroupModule:(scorecardId : string): void => {
        window.location.href = (`${createGroupModuleExternalRedirect}${scorecardId}`);
    },

    CreateConsolidatedScorecard:(scorecardId : string, navigate: (path: string) => void): void => {
        navigate(`/bee/scorecard/${scorecardId}/createconsolidations`);
    }
};
